import { lazy } from 'react';

export const LoginContainer = lazy(() => import('containers/Auth/Login/LoginContainer'));

export const RecoverPasswordContainer = lazy(() => import('containers/Auth/RecoverPassword/RecoverPassword'));

export const SetNewPasswordContainer = lazy(() => import('containers/Auth/SetNewPassword/SetNewPassword'));

export const PageNotFoundContainer = lazy(() => import('containers/PageNotFound/PageNotFoundContainer'));

export const DashboardScreenContainer = lazy(() => import('containers/Dashboard/DashboardContainer'));

export const ProductScreenContainer = lazy(() => import('containers/Product/ProductContainer'));

export const ProfileScreenContainer = lazy(() => import('containers/Profile/ProfileContainer'));

export const ProductDetailContainer = lazy(() => import('containers/ProductDetail/ProductDetailContainer'));

export const ProductDetailEditContainer = lazy(() => import('containers/ProductDetailEdit/ProductDetailEditContainer'));

export const ProductVariationDetailContainer = lazy(() => import('containers/ProductVariantDetail/ProductVariantDetailContainer'));

export const ProductVariationEditContainer = lazy(() => import('containers/ProductVariationEdit/ProductVariationEditContainer'));

export const TrainingVideosContainer = lazy(() => import('containers/TrainingVideos/TrainingVideosContainer'));

export const TrainingVideoDetailsContainer = lazy(() => import('containers/TrainingVideoDetails/TrainingVideoDetailsContainer'));

export const UsersContainer = lazy(() => import('containers/Users/Users'));

export const EditorContainer = lazy(() => import('containers/Editor/Editor'));

export const NotificationsContainer = lazy(() => import('containers/Notifications/Notifications'));

export const SubCategoryContainer = lazy(() => import('containers/SubCategory/SubCategory'));

export const HomeContainer = lazy(() => import('containers/Home/Home'));

export const PublicProductContainer = lazy(() => import('containers/PublicProduct'));

export const ProductConfigurationContainer = lazy(() => import('containers/ProductConfiguration'));

export const SelectedRoomContainer = lazy(() => import('containers/SelectedRoom/SelectedRoom'));

export const CategoryDetailsContainer = lazy(() => import('containers/CategoryDetails/CategoryDetailsContainer'));

export const SearchContainer = lazy(() => import('containers/SearchPage/SearchPage'));

export const TagSearchContainer = lazy(() => import('containers/TagSearch/TagSearch'));

export const PublicVariationContainer = lazy(() => import('containers/PublicVariation'));
